import React, {useState, useRef, useEffect} from 'react';
import './App.css';
import copy from 'copy-to-clipboard'
import toast, { Toaster } from 'react-hot-toast';
import { API_URL } from './config';
import  marked  from "marked";

const ChatMessage = ({ message, isUser, isError, answers }) => {
  const [adjustAnswer, setAdjustAnswer] = useState(answers === undefined ? '' : answers.referAnswer);
  const [adjustQuestion, setAdjustQuestion] = useState( answers === undefined ?  '' : answers.referQuestion);
  const [isAnswerEdit, setAnswerEdit] = useState(true)
  const [isQuestionEdit, setQuestionEdit] = useState(true)
  const [textColorAnswer, setTextColorAnswer] = useState('gray')
  const [textColorQuestion, setTextColorQuestion] = useState("gray")
  const onAnswerEdit = () => {
    setAnswerEdit(false)
    setTextColorAnswer('black')
  }

  const onQuestionEdit = () => {
    setQuestionEdit(false)
    setTextColorQuestion('black')
  }

  const [btnStyle, setBtnStyle] = useState({
    width: '100px',
    height: '30px',
    marginLeft: '20px',
    borderRadius: '8px',
  });

  
  //点赞
  const [isLikeEnable, setIsLikeEnable] = useState(true);
  const [likeSrc, setLikeSrc] = useState(require('./img/like.svg'))
  //
  const [isDisLikeEnable, setIsDisLikeEnable] = useState(true);
  const [disLikeSrc, setDisLikeSrc] = useState(require('./img/dislike.svg'))

  let [isShowSrc, setIsShowSrc] = useState(false)

  //是否展示配置回答
  let [isEditReply, setEditReply] = useState(true)

  const handleAnswerInputChange = (e) => {
    setAdjustAnswer(e.target.value);
  };
  const handleQuestionInputChange = (e) => {
    setAdjustQuestion(e.target.value);
  };

  //点赞
  const onLike = () => {

    setIsDisLikeEnable(true)
    setDisLikeSrc(require('./img/dislike.svg'))
    if (answers === undefined) {
    } else {
      handleLikePost(answers, 1)
    }

    setIsLikeEnable(false);
    setLikeSrc(require('./img/like_click.svg'))
  }
  function  isEmptyString(str) {
    if (str === "" || /^\s*$/.test(str)) {
      return true;
    } else {
      return false;
    }
  }


  const onAdjustAnswer = () => {
    if (isEmptyString(adjustAnswer) || isEmptyString(adjustQuestion)) {
      toast("问题或回答不能为空")
      return
    }
    let strData = {
      referID: answers.referID,
      newQuestion: adjustQuestion,
      newAnswer: adjustAnswer
    };

    let httpRequest = new XMLHttpRequest();

    httpRequest.open('POST', `${API_URL}/modifyQuestionAnswer`, true);
    httpRequest.setRequestHeader("Accept", "application/json");
    httpRequest.setRequestHeader("Content-type", "application/json");

    let json = JSON.stringify(strData)
    httpRequest.send(json);

    httpRequest.onload = function () {//
      let json = httpRequest.responseText;
      console.log(json)
      let obj = JSON.parse(decodeURIComponent(json));
      if (obj.success) {
        toast("修改成功")
      } else {
        toast("修改失败")
      }
    };
  }


  const onUnLike=() => {
    setIsLikeEnable(true);
    setLikeSrc(require('./img/like.svg'))
    console.log("answer: " + answers)
    if (answers === undefined) {
      console.log("answer 没有定义")
    } else {
      handleLikePost(answers, 2)
    }
    setIsDisLikeEnable(false)
    setDisLikeSrc(require('./img/dislike_click.svg'))
  }
  //点赞接口
  const handleLikePost = async (answers, feedback) =>
  {
    var id = answers.referId
    let strData = {
      id: id,
      feedback: feedback
    };
    let httpRequest = new XMLHttpRequest();
    httpRequest.open('POST', `${API_URL}/document/like`, true);
    httpRequest.setRequestHeader("Accept", "application/json");
    httpRequest.setRequestHeader("Content-type", "application/json");
    let json = JSON.stringify(strData)
    httpRequest.send(json);

    httpRequest.onload = function () {//
      if (httpRequest.readyState === 4 && httpRequest.status === 200) {
          let json = httpRequest.responseText;
          console.log(json)
      }
    };
  }

  //复制
  const copybt= (param) => () =>
  {
    copy(param)
    toast("Copied successfully")
  }

  const showSrc = () => {
    if (isShowSrc) {
      setIsShowSrc(false)
      isShowSrc = false
    } else {
      setIsShowSrc(true)
      isShowSrc = true
    }
  }

  const showEditReplay = () => {
    if (isEditReply) {
      isEditReply = false;
      setEditReply(false)
    } else {
      isEditReply = true
      setEditReply(true)
    }
  }

  const textareaRefUser = useRef(null);
  const textareaRefBot = useRef(null);

  // 获取文本的宽度
  const getTextWidth = (textareCom) => {
    const text = textareCom.value
    
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = getComputedStyle(document.body).fontSize + ' Arial';
    let width = context.measureText(text).width * 1.8;
    let screenWidth = window.innerWidth ;
    textareCom.style.width = '100%';
    textareCom.style.height = 'auto';
    textareCom.style.height = textareCom.scrollHeight + "px"; // 让高度适应内容
    if(text.length <= 20){
      const lineHeight = 52;
      const minRows = 1; // 确保至少一行
      textareCom.style.height = `${minRows * lineHeight}px`; // 动态设置高度
    }
  };

  const autoResize = () => {
    if(textareaRefUser.current){
      getTextWidth(textareaRefUser.current);
    }
    if(textareaRefBot.current){
      // 重置高度以便重新计算
      textareaRefBot.current.style.height = 'auto';
      // 设置高度为滚动高度
      textareaRefBot.current.style.height = `${textareaRefBot.current.scrollHeight}px`;
    }
  };


  useEffect(() => {
    // 组件挂载时初始化一次
    autoResize();
  }, []);

  const handleInputChange = (e) => {
      e.target.style.height = 'auto'; // 重置高度以便重新计算
      e.target.style.height = `${e.target.scrollHeight}px`; // 设置高度为滚动高度
  };

  function compressBlankLines(markdown) {
    return markdown.replace(/\n\s*\n\s*/g, '\n');
  }

  return (
    <div>
      {!isError && !isUser &&
        <div className='container-left'>
          <label className='AIHeadLabel'>
          </label>
          <div className='chat-message-bot'  dangerouslySetInnerHTML={{ __html: marked(compressBlankLines(message)) }}
            readOnly={true}
            ref={textareaRefBot}
          >
          </div> 
        </div>
      }

      {!isError && isUser &&
        <div className='container-right'>
          <textarea className='chat-message-user' value={message}
          readOnly={true}
          onChange={handleInputChange}
          ref={textareaRefUser}
          >
          </textarea>
          <label className='UserHeadLabel'>
          </label>
      </div>
      }

      {   !isUser && !isError &&
          <div className={'chat-message-container'}>
            <div className={'chat-message-container-img'}>
              <img className={'chat-message-img'} src={likeSrc}
                   alt='img'
                   onClick={onLike}
                   title={"like"}
                   tabIndex={isLikeEnable ? -1 : 0}
              >
              </img>

              <img className={'chat-message-img'}
                   src={disLikeSrc}
                   alt='es-lint'
                   title={'disagree'}
                   onClick={onUnLike}
                   tabIndex={isDisLikeEnable ? -1 : 0}
              >
              </img>


              <img className={'chat-message-img'}
                   src={require('./img/copy.svg')}
                   alt='es-lint'
                   title={'Copy'}
                   onClick={copybt(message)}>
              </img>
              <Toaster/>

            </div>
          </div>
      }

      {
          isShowSrc && !isUser && !isEditReply &&
          <div className={'chat-message-adjust'}>

            <button
                onClick={showEditReplay}>
              Adjust answer
            </button>
          </div>
      }
     
      {isError &&
          <div className='chat-message-user-error'>
            {message}
          </div>
      }

    </div>


  );
};

export default ChatMessage;
